import { fromHouseConsignmentDetailsResponse, toCreateHouseConsignmentRequest } from '../models/mapper'
import { HouseConsignmentCreate } from '../models/request'
import { HouseConsignmentDetails } from '../models/types'
import { createHouseConsignmentV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createHouseConsignment(data: HouseConsignmentCreate): Promise<HouseConsignmentDetails> {
  const response = await createHouseConsignmentV3(toCreateHouseConsignmentRequest(data))
  return fromHouseConsignmentDetailsResponse(response)
}
